import ApiClient from '@afosto/api/ApiClient';

class Services {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create services
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new service
   * @returns {Promise}
   */
  createService(body, options = {}) {
    return this.apiClient.request({
      url: `/odr/services`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * View services
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get a single service by ID
   * @returns {Promise}
   */
  getService(id, options = {}) {
    return this.apiClient.request({
      url: `/odr/services/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get services
   *
   * @param {Object} options - The additional request options
   * @description Get a listing of available services
   * @returns {Promise}
   */
  getServices(options = {}) {
    return this.apiClient.request({
      url: `/odr/services`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Update service
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Get a single service by ID
   * @returns {Promise}
   */
  updateService(id, body, options = {}) {
    return this.apiClient.request({
      url: `/odr/services/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const services = new Services();

export default Services;
